export default {
  NEW: {
    icon: 'plus',
    type: '',
    text: 'Novo',
  },
  PROCESSING: {
    icon: 'sync',
    type: 'has-text-grey-light',
    text: 'Processando...',
  },
  RECONCILED: {
    icon: 'handshake',
    type: 'has-text-grey-light',
    text: 'Conciliado',
  },
  APPROVED: {
    icon: 'check',
    type: 'has-text-primary',
    text: 'Aprovado',
  },
  PAID: {
    icon: 'thumbs-up',
    type: 'has-text-info',
    text: 'Pago',
  },
  ANALYZED: {
    icon: 'check-square',
    type: 'has-text-primary',
    text: 'Analisado',
  },
  ERROR: {
    icon: 'times',
    type: 'has-text-danger',
    text: 'Erro',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/enums/EnumInvoiceAuditStatus.js